// extracted by mini-css-extract-plugin
module.exports = {"filter-panel":"filterpanel_filter-panel__39RAZ"};